import dayjs from 'dayjs';

export const actorName = (user) => {
  if (!user) return '—';
  if (typeof user === 'string') return user;
  const full = [user.name, user.last_name].filter(Boolean).join(' ').trim();
  return full || user.email || '—';
};

export const formatDate = (value) => {
  if (!value) return '—';
  const date = dayjs(value);
  return date.isValid() ? date.format('MMM D, YYYY h:mm A') : '—';
};

export const auditColumns = [
  {
    title: 'Added by',
    key: 'created_by',
    width: 160,
    render: (_, record) => actorName(record.created_by),
  },
  {
    title: 'Updated by',
    key: 'updated_by',
    width: 160,
    render: (_, record) => actorName(record.updated_by),
  },
  {
    title: 'Last updated',
    key: 'updated_at',
    width: 180,
    render: (_, record) => formatDate(record.updated_at),
  },
];
